import React, { useState } from 'react';
import './Categories.css';
import { motion, AnimatePresence } from 'framer-motion';

const categories = [
  {
    id: 'formal',
    name: 'FORMAL',
    images: [
      "https://blacksalt.ascentbw.com/Images/Category/For1.webp",
      "https://blacksalt.ascentbw.com/Images/Category/For2.webp",
      "https://blacksalt.ascentbw.com/Images/Category/For3.webp"
    ]
  },
  {
    id: 'casual',
    name: 'CASUAL',
    images: [
      "https://blacksalt.ascentbw.com/Images/Category/Cau1.webp",
      "https://blacksalt.ascentbw.com/Images/Category/Cau2.webp",
      "https://blacksalt.ascentbw.com/Images/Category/Cau3.webp"
    ]
  },
  {
    id: 'prints-1',
    name: 'PRINTS',
    images: [
      "https://blacksalt.ascentbw.com/Images/Category/Pri1.webp",
      "https://blacksalt.ascentbw.com/Images/Category/Pri2.webp",
      "https://blacksalt.ascentbw.com/Images/Category/Pri3.webp"
    ]
  },
  {
    id: 'trousers',
    name: 'TROUSERS',
    images: [
      "https://blacksalt.ascentbw.com/Images/Category/Tro1.webp",
      "https://blacksalt.ascentbw.com/Images/Category/Tro2.webp",
      "https://blacksalt.ascentbw.com/Images/Category/Tro3.webp"
    ]
  },
  {
    id: 'stripes',
    name: 'STRIPES',
    images: [
      "https://blacksalt.ascentbw.com/Images/Category/Strip1.webp",
      "https://blacksalt.ascentbw.com/Images/Category/Strip2.webp",
      "https://blacksalt.ascentbw.com/Images/Category/Strip3.webp"
    ]
  }
];

const Categories = () => {
  const [activeId, setActiveId] = useState(categories[1].id);

  const activeCategory = categories.find(cat => cat.id === activeId);

  return (
    <section className="categories" id="categories">
      <div className="category-left">
        <div className="section-header">
          <motion.div 
            className="section-label"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            CATEGORIES
          </motion.div>
        </div>
        <div className="category-list">
          {categories.map((cat) => (
            <motion.div
              key={cat.id}
              className={`category-item ${activeId === cat.id ? 'active' : ''}`}
              onClick={() => setActiveId(cat.id)}
              animate={{ 
                color: activeId === cat.id ? '#000000' : '#cccccc',
              }}
              whileHover={{ x: 10, color: '#cc0000' }}
            >
              {cat.name}
            </motion.div>
          ))}
        </div>
      </div>
      <div className="category-images">
        <AnimatePresence mode="wait">
          <motion.div 
            key={activeId}
            className="category-img-grid"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
          >
            {activeCategory.images.map((img, idx) => (
              <div key={idx} className="cat-img-box">
                <img src={img} alt={`${activeCategory.name} ${idx}`} />
              </div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default Categories;
